export default __webpack_public_path__ + "static/media/Round_B240_re.23ad1b13.png";